import type { ChangeEvent } from 'react';

type Project = {
  id: string;
  name: string;
  client_name?: string;
};

type Props = {
  projects: Project[];
  selected: Project | null;
  onChange: (project: Project) => void;
};

export function ProjectSwitcher({ projects, selected, onChange }: Props) {
  if (projects.length <= 1) return null;

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const next = projects.find((p) => p.id === e.target.value);
    if (next) onChange(next);
  };

  return (
    <label className="mt-2 block">
      <span className="sr-only">Switch project</span>
      <select
        className="w-full rounded border border-gray-200 bg-gray-100 px-2 py-1 text-xs text-gray-700 focus:outline-none focus:ring-1 focus:ring-indigo-500"
        value={selected?.id ?? ''}
        onChange={handleChange}
      >
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
      </select>
    </label>
  );
}
